import React, { useEffect, useState } from "react";
import PageTitle from "../../../Module/pageTitle";
import LabelField from "../../../Component/labelField";
import CustomDropdown from "../../../Component/customDropdown";
import {
  deleteTeacherData,
  editTeacherData,
  getAllTeachersList,
  getExamListNew,
  getParentCourseNew,
  getTeacherData,
  setParentCourse,
  uploadTeacherImg,
  uploadYoutubeReferredImage,
} from "../../../Action/courseAction";
import { useDispatch } from "react-redux";
import AdminTable from "../../../Component/adminTable";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import {
  containsNumber,
  image_size_150,
  length_Five,
  length_Ten,
  length_TwoHundred,
  pdf_size_1MB,
  validateIsFileImageType,
} from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import { showErrorSnackbar } from "../../../Action/snackbarAction";
import InputField from "../../../Component/inputField";
import {
  getLanguage,
  getSubExam,
  getSubjectList,
} from "../../../Action/adminPanelAction";
import FormInputField from "../../../Component/FormInputField";
import SubmitButton from "../../../Component/SubmitButton";

const EditFreeYTLectures = () => {
  const dispatch = useDispatch();
  const initialVal = {
    examName: "",
    subExamName: "",
    parentCourseVal: "",
    teacherName: "",
    subjectName: "",
    examList: [],
    subExamList: [],
    parentCourseList: [],
    teacherList: [],
    subjectList: [],
    teacherLecture: [],
    resetExam: false,
    resetSubExam: false,
    resetParentCourse: false,
    resetTeacherList: false,
    resetTeacherName: false,
    resetTeacherLecture: false,
    resetlanguageId: false,
  };
  const [isEdit, setIsEdit] = useState(false);
  const [states, setStates] = useState(initialVal);
  const [teacherImage, setTeacherImage] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [lectureTopic, setLectureTopic] = useState("");
  const [lectureTitle, setLectureTitle] = useState("");
  const [lectureUrl, setLectureUrl] = useState("");
  const [lectureId, setLectureId] = useState("");
  const [order, setOrder] = useState("");
  const [awsUrl, setAwsUrl] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [thumbnailView, setThumbnailView] = useState("");
  const [languageList, setLanguageList] = useState([]);
  const [languageId, setLanguageId] = useState("");
  const [languageIdSearch, setLanguageIdSearch] = useState("");

  const onChangeData = (value, type) => {
    if (type === "examName") {
      setStates((prevState) => ({
        ...prevState,
        examName: value,
        resetExam: false,
        resetlanguageId: true,
        resetParentCourse: true,
        resetTeacherName: true,
        subExamName: "",
        parentCourseVal: "",
        teacherName: "",
        subjectName: "",
        teacherLecture: [],
      }));
      setLanguageIdSearch("");
      dispatch(
        getSubExam(
          {
            examTypeId: value._id,
          },
          (res) => {
            if (res?.data.length > 0) {
              setStates((prevState) => ({
                ...prevState,
                subExamList: res?.data,
              }));
            } else {
              dispatch(
                getParentCourseNew(`${value._id}`, (res) => {
                  setStates((prevState) => ({
                    ...prevState,
                    parentCourseList: res,
                  }));
                })
              );
            }
          }
        )
      );
    } else if (type === "subExam") {
      setStates((prevState) => ({
        ...prevState,
        subExamName: value,
        resetSubExam: false,
      }));
      dispatch(
        getParentCourseNew(`${states?.examName._id}/${value._id}`, (res) => {
          setStates((prevState) => ({
            ...prevState,
            parentCourseList: res,
          }));
        })
      );
    } else if (type === "parentCourse") {
      setStates((prevState) => ({
        ...prevState,
        parentCourseVal: value,
        resetParentCourse: false,
      }));
      dispatch(
        getAllTeachersList(
          {
            skip: 0,
            limit: 100,
          },
          (res) => {
            setStates((prevState) => ({
              ...prevState,
              teacherList: res?.data?.data,
            }));
          },
          () => {}
        )
      );
      dispatch(
        getSubjectList(
          {
            examTypeId: states?.examName._id,
            subExamTypeId: states?.subExamName._id,
            baseCourseId: value?._id,
          },
          (res) => {
            if (res) {
              setStates((prevState) => ({
                ...prevState,
                subjectList: res?.data,
              }));
            }
          }
        )
      );
    } else if (type === "subject") {
      setStates((prevState) => ({
        ...prevState,
        subjectName: value,
      }));
    } else if (type === "teachers") {
      setStates((prevState) => ({
        ...prevState,
        teacherName: value,
        resetTeacherName: false,
      }));
      let reqBody = {
        examTypeId: states?.examName?._id,
        baseCourseId: states?.parentCourseVal?._id,
        teacherId: value?._id,
      };
      if (states?.subExamName) {
        reqBody.subExamTypeId = states?.subExamName?._id;
      }
      if (states?.subjectName?._id) {
        reqBody.subjectId = states?.subjectName?._id;
      }
      if (languageIdSearch) {
        reqBody.languageId = languageIdSearch;
      }
      dispatch(
        getTeacherData(reqBody, (resp) => {
          setStates((prevState) => ({
            ...prevState,
            teacherLecture: resp,
          }));
        })
      );
    }
  };
  const handleSearchLanguage = (value) => {
    setLanguageIdSearch(value?._id);
    setStates((prevState) => ({
      ...prevState,
      teacherName: "",
      resetTeacherName: true,
      resetParentCoursee: true,
      resetlanguageId: false,
    }));
  };
  const renderFirstForm = () => {
    return (
      <div className="row">
        <div className=" col-md-4">
          <div className="d-flex mb-2 align-items-center">
            <LabelField labelName={"Exam Name"} isRequired={true} />
            <CustomDropdown
              setInputText={(value) => onChangeData(value, "examName")}
              value={states?.examName}
              options={states?.examList}
              labelName="Select Exam Name"
              reset={states?.resetExam}
              disabled={isEdit}
            />
          </div>
        </div>
        {states?.subExamList?.length > 0 ? (
          <div className="col-md-4 d-flex mb-2 align-items-center">
            <LabelField labelName={"Sub Exam Name"} isRequired={true} />
            <CustomDropdown
              setInputText={(value) => onChangeData(value, "subExam")}
              value={states?.subExamName}
              options={states?.subExamList}
              labelName="Select Sub Exam Name"
              reset={states?.resetSubExam}
              disabled={isEdit}
            />
          </div>
        ) : null}

        <div className="col-md-4 d-flex mb-2 align-items-center">
          <LabelField labelName={"Exam Stream"} isRequired={true} />
          <CustomDropdown
            setInputText={(value) => onChangeData(value, "parentCourse")}
            value={states?.parentCourseVal}
            options={states?.parentCourseList}
            labelName="Select Exam Name"
            reset={states?.resetParentCourse}
            disabled={isEdit}
          />
        </div>
        <div className="col-md-4 d-flex align-items-center">
          <LabelField labelName={"Subject"} isRequired={true} />
          <CustomDropdown
            setInputText={(value) => onChangeData(value, "subject")}
            value={states?.subjectName}
            options={states?.subjectList}
            labelName="Select Subject"
            reset={states?.resetParentCourse}
            disabled={isEdit}
          />
        </div>
        <div className="col-md-4 d-flex align-items-center">
          <LabelField labelName={"Package Language"} />
          <CustomDropdown
            labelName="Select Package Language"
            setInputText={(value) => handleSearchLanguage(value)}
            options={languageList}
            value={languageIdSearch}
            reset={states?.resetlanguageId}
            disabled={isEdit}
          />
        </div>

        <div className="col-md-4 d-flex mb-2 align-items-center">
          <LabelField labelName={"Teacher Name"} isRequired={true} />
          <CustomDropdown
            labelName="Select Teacher Name"
            setInputText={(value) => onChangeData(value, "teachers")}
            options={states?.teacherList}
            value={states?.teacherName}
            defaultValue={states?.teacherName}
            reset={states?.resetTeacherName}
            disabled={isEdit}
          />
        </div>
      </div>
    );
  };
  const renderListMode = () => {
    return (
      <div className="col-12">
        <AdminTable
          tableData={states?.teacherLecture ? states?.teacherLecture : []}
          pagename={"teacherLecture"}
          tableHead={[
            "S.N",
            "Lecture Title",
            "Exam Name",
            "Sub Exam Name",
            "Exam Stream",
            "Teacher Name",
            "Priority Order",
            "Actions",
          ]}
          handleEdit={(value) => handleEdit(value)}
          handleDelete={(value) => handleDelete(value)}
          edit={true}
        />
      </div>
    );
  };
  const handleTeacherImg = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > image_size_150) {
      dispatch(showErrorSnackbar("File size should be less than 150 KB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        setTeacherImage(reader?.result);
        setSelectedImage(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const handelChangeOrder = (value) => {
    if (containsNumber(value) || value === "") {
      setOrder(value);
    }
  };

  const onChangeYouTubeThumbnail = (value) => {
    value.preventDefault();

    if (!validateIsFileImageType(value)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (value.target.files[0].size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
    } else {
      const file = value.target.files[0];
      dispatch(
        uploadYoutubeReferredImage(file, (resCover) => {
          if (resCover) {
            const reader = new FileReader();
            reader.onloadend = () => {
              setThumbnail(resCover?.link);
              setThumbnailView(reader.result);
            };
            reader.readAsDataURL(file);
          } else {
            dispatch(showErrorSnackbar("File Not Uploaded"));
          }
        })
      );
    }
  };

  const renderEditMode = () => {
    return (
      <div className="col-7">
        <form onSubmit={handleSubmit}>
          <div className="d-flex">
            <LabelField labelName={"Priority Order"} isRequired={true} />
            <FormInputField
              value={order}
              placeholder={`Enter Priority Order`}
              setInputText={(value) => handelChangeOrder(value)}
              maxLength={5}
            />
          </div>
          <div className="p-1">
            <ImagePickerAndViewer
              labelName={"Upload Teacher Image"}
              value={teacherImage}
              handleChange={(e) => handleTeacherImg(e)}
              htmlFor={"photo-upload"}
              isRequired={true}
            />
            <div className="d-flex">
              <LabelField labelName={"Lecture Topic"} isRequired={true} />
              <FormInputField
                value={lectureTopic}
                placeholder={`Enter Lecture Topic`}
                setInputText={(value) => setLectureTopic(value)}
                minLength={length_Five}
                maxLength={length_TwoHundred}
              />
            </div>
            <div className="d-flex">
              <LabelField labelName={"Lecture Title"} isRequired={true} />
              <FormInputField
                value={lectureTitle}
                placeholder={`Enter Lecture Title`}
                setInputText={(value) => setLectureTitle(value)}
                minLength={length_Five}
                maxLength={length_TwoHundred}
              />
            </div>

            <ImagePickerAndViewer
              labelName={"Thumbnail Image"}
              value={thumbnailView || thumbnail}
              handleChange={onChangeYouTubeThumbnail}
              htmlFor={`photo-upload1`}
              type="file"
              isRequired={true}
            />

            <div className="d-flex">
              <LabelField labelName={"Lecture Url"} />
              <FormInputField
                value={lectureUrl}
                placeholder={`Enter Lecture Url`}
                setInputText={(value) => setLectureUrl(value)}
                minLength={length_Ten}
                maxLength={length_TwoHundred}
              />
            </div>
            <div className="d-flex">
              <LabelField labelName={`AWS Url`} />
              <FormInputField
                value={awsUrl}
                placeholder={`Enter AWS Url`}
                setInputText={(value) => setAwsUrl(value)}
                minLength={length_Ten}
              />
            </div>
            <div className="d-flex align-items-center">
              <LabelField labelName={"Package Language"} isRequired />
              <CustomDropdown
                labelName="Select Package Language"
                setInputText={(value) => setLanguageId(value?._id)}
                options={languageList}
                value={languageId}
                defaultValue={languageId}
              />
            </div>
            <SubmitButton name="Save & Update" validations={validations()} />
          </div>
        </form>
      </div>
    );
  };

  const validations = () => {
    return (
      lectureTitle === "" ||
      lectureTopic === "" ||
      order === "" ||
      thumbnail === "" ||
      awsUrl === "" ||
      !languageId
      // lectureUrl === ""
    );
  };

  const handleEdit = (value) => {
    setTeacherImage(value?.teacherImage);
    setLectureId(value?._id);
    setLectureTitle(value?.title);
    setLectureTopic(value?.topic);
    setThumbnail(value?.thumbnail);
    setLectureUrl(value?.url);
    setAwsUrl(value?.awsUrl);
    setOrder(value?.order);
    setLanguageId(value?.languageId?._id);
    setIsEdit(true);
    dispatch(setParentCourse("isEditMode", true));
  };

  const handleDelete = (value) => {
    dispatch(
      deleteTeacherData(value?._id, async () => {
        let reqBody = {
          examTypeId: states?.examName?._id,
          baseCourseId: states?.parentCourseVal?._id,
          teacherId: states?.teacherName?._id,
        };
        if (states?.subExamName) {
          reqBody.subExamTypeId = states?.subExamName?._id;
        }
        dispatch(
          getTeacherData(reqBody, (resp) => {
            setStates((prevState) => ({
              ...prevState,
              teacherLecture: resp,
            }));
          })
        );
      })
    );
  };

  const handleCancelEditMode = () => {
    setIsEdit(false);
    setThumbnailView("");
    dispatch(setParentCourse("isEditMode", false));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const { examName, subExamName, parentCourseVal, teacherName, subjectName } =
      states;
    dispatch(
      uploadTeacherImg(selectedImage, async (res) => {
        const reqBody = {
          examTypeId: examName?._id,
          subExamTypeId: subExamName?._id,
          baseCourseId: parentCourseVal?._id,
          subjectId: subjectName?._id,
          teacherId: teacherName?._id,
          title: lectureTitle,
          thumbnail: thumbnail,
          url: lectureUrl,
          awsUrl: awsUrl,
          topic: lectureTopic,
          order: parseInt(order),
          languageId: languageId,
        };
        if (selectedImage) {
          reqBody.teacherImage = res?.file;
        }
        dispatch(
          editTeacherData(reqBody, lectureId, () => {
            setIsEdit(false);
            let reqBody = {
              examTypeId: states?.examName?._id,
              baseCourseId: states?.parentCourseVal?._id,
              teacherId: states?.teacherName?._id,
            };
            if (states?.subExamName) {
              reqBody.subExamTypeId = states?.subExamName?._id;
            }
            if (states?.subjectName?._id) {
              reqBody.subjectId = states?.subjectName?._id;
            }
            if (languageIdSearch) {
              reqBody.languageId = languageIdSearch;
            }
            dispatch(
              getTeacherData(reqBody, async (resp) => {
                setStates((prevState) => ({
                  ...prevState,
                  teacherLecture: resp,
                }));
              })
            );
          })
        );
      })
    );
  };
  useEffect(() => {
    dispatch(
      getExamListNew((res) => {
        setStates((prevState) => ({
          ...prevState,
          examList: res,
        }));
      })
    );
    dispatch(
      getLanguage((res) => {
        setLanguageList(res.data.data);
      })
    );
  }, []);
  return (
    <div className="contentBox">
      <PageTitle
        name={"EDIT / DELETE"}
        isEditMode={isEdit}
        onClick={handleCancelEditMode}
      />
      <div className="row formDiv contentScrollbar m-0">
        <div className="col-12 formWidth pt-3">
          <div className="col-md-12 w-100">{renderFirstForm()}</div>
          {!isEdit ? renderListMode() : renderEditMode()}
        </div>
      </div>
    </div>
  );
};

export default EditFreeYTLectures;
